module.exports = __webpack_public_path__ + "img/arlapro-PAH.361ec2e0.png";